"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _tcomb = require("tcomb");

var t = _interopRequireWildcard(_tcomb);

var _lodash = require("lodash");

var _ = _interopRequireWildcard(_lodash);

var _selectn = require("selectn");

var _selectn2 = _interopRequireDefault(_selectn);

var _AppDataField = require("../AppDataField");

var _TcombReactWidgetsDateTemplate = require("../../../../components/TcombReactWidgetsDateTemplate");

var _TcombReactWidgetsDateTemplate2 = _interopRequireDefault(_TcombReactWidgetsDateTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var moment = require("moment");

var DateAppDataField = function DateAppDataField(dataField, contentDataField) {
    var _this = this;

    var isWithinTable = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

    _classCallCheck(this, DateAppDataField);

    this.key = function () {
        return _this.dataField.uid;
    };
    this.currentFormValue = function () {
        return (0, _selectn2.default)("data.value", _this.contentDataField);
    };
    this.setValue = function (value) {
        value = value || null;
        if (value === "today") {
            value = moment(new Date()).toLocaleString("de_AT");
        }
        _.set(_this, "contentDataField.data.value", value);
    };
    this.dateType = function () {
        return t.refinement(t.String, function (v) {
            var isValidDate = Date.parse(v) ? true : false;
            var isValidDefault = _.isEmpty(_this.dataField.default) === false && v === _this.dataField.default;
            return isValidDate || isValidDefault; // default value must not be a date and is also allowed to be set!
        });
    };
    this.appSchemaObject = function () {
        var schema = {};
        _.set(schema, _this.key(), _this.dataField.isMandatory ? _this.dateType() : t.maybe(_this.dateType()));
        return schema;
    };
    this.appSchemaStruct = function () {
        return t.struct(_this.appSchemaObject(), _this.dataField.uid);
    };
    this.appSchemaFieldOptions = function (formattedMessage) {
        var disabled = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

        var field = {};
        _.set(field, _this.key(), {
            label: (0, _AppDataField.labelHelper)(_this.dataField.title, _this.dataField.isMandatory, _this.isWithinTable, formattedMessage),
            config: {
                momentDateFormatterString: "DD.MM.YYYY"
            },
            help: (0, _AppDataField.helpContainer)(true, _this.dataField.description),
            template: _this.template,
            disabled: disabled
        });
        return field;
    };
    this.template = function (locals) {
        return React.createElement("div", { style: { "width": _AppDataField.containerWidth } }, (0, _TcombReactWidgetsDateTemplate2.default)(locals));
    };
    this.copy = function () {
        return new DateAppDataField(_this.dataField, _this.contentDataField);
    };
    this.contentDataField = contentDataField;
    this.dataField = dataField;
    this.isWithinTable = isWithinTable;
    this.contentDataField = Object.assign({}, contentDataField, {
        type: "value",
        uid: dataField.uid
    });
    var currentFormValue = this.currentFormValue();
    if (!currentFormValue) {
        this.setValue(this.dataField.default);
    } else {
        this.setValue(currentFormValue);
    }
};

exports.default = DateAppDataField;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/reducers/reportDetail/fields/DateAppDataField.tsx
 ** module id = 1293
 ** module chunks = 0
 **/